module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lohn-a6f39232a6d4fd6724ebe6dfaba1dd7f.png";